import { StreamingChannelIdInput } from "@/components/inputs/StreamingChannelIdInput";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CmsFeaturedStreamingChannelBlock } from "@/gen/realtime";
import { useImageUpload } from "@/hooks/use-image-upload";
import { generateImageUrl } from "@/utils/image";

export const FeaturedStreamingChannelForm = ({
    block,
    setBlock,
}: {
    block: CmsFeaturedStreamingChannelBlock;
    setBlock: (mutate: (block: CmsFeaturedStreamingChannelBlock) => void) => void;
}) => {
    const { startSelectFile, inputProps, inputId, isUploading } = useImageUpload({
        onUploadFinished: imageId => {
            setBlock(draft => {
                draft.backgroundImageId = imageId;
            });
        },
    });

    return (
        <div className="space-y-4">
            <h3 className="text-lg font-medium">Featured Streaming Channel</h3>

            <div>
                <Label htmlFor="streaming-channel-id">Streaming Channel</Label>
                <StreamingChannelIdInput
                    streamingChannelId={block.streamingChannelId}
                    onStreamingChannelIdChange={channelId => {
                        setBlock(draft => {
                            draft.streamingChannelId = channelId;
                        });
                    }}
                />
            </div>

            <div>
                <Label htmlFor="title">Title (optional)</Label>
                <Input
                    id="title"
                    value={block.title ?? ""}
                    onChange={e => {
                        const value = e.target.value;
                        setBlock(draft => {
                            draft.title = value ? value : null;
                        });
                    }}
                    placeholder="Custom title for the stream block"
                />
            </div>

            <div className="space-y-2">
                <input {...inputProps} />
                <Label htmlFor={inputId}>Background Image (optional)</Label>
                {block.backgroundImageId ? (
                    <div className="space-y-2">
                        <img
                            key={block.backgroundImageId}
                            src={generateImageUrl({
                                imageId: block.backgroundImageId,
                                width: 200,
                                height: 112,
                                fit: "crop",
                            })}
                            className="rounded border"
                            alt="Background"
                        />
                        <div className="flex gap-2">
                            <Button
                                variant="secondary"
                                size="sm"
                                onClick={() => startSelectFile()}
                                disabled={isUploading}
                            >
                                {isUploading ? "Uploading..." : "Change"}
                            </Button>
                            <Button
                                variant="outline"
                                size="sm"
                                onClick={() => {
                                    setBlock(draft => {
                                        draft.backgroundImageId = null;
                                    });
                                }}
                            >
                                Remove
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <Button
                            variant="secondary"
                            onClick={() => startSelectFile()}
                            disabled={isUploading}
                        >
                            {isUploading ? "Uploading..." : "Upload background image"}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};
